import { render, staticRenderFns } from "./pictureBlockCreate.vue?vue&type=template&id=59c31e6e&"
import script from "./pictureBlockCreate.vue?vue&type=script&lang=js&"
export * from "./pictureBlockCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports